import React from "react";
import { useTranslation } from "../../../../i18n/client";
import Features from "./Features";
import Partners from "./Partners";
import NavigationButton from "./NavigationButton";
import featureApi from "../../../../../public/images/New-landing/feature-api.png";
import featureWorkflows from "../../../../../public/images/New-landing/feature-workflows.png";
import featureScanGo from "../../../../../public/images/New-landing/feature-scan-go.png";
import featureAiModels from "../../../../../public/images/New-landing/feature-ai-models.png";
import feature5g from "../../../../../public/images/New-landing/feature-5g.png";
import featureEngine from "../../../../../public/images/New-landing/feature-engine.png";
import partnerRoske from "../../../../../public/images/New-landing/partner-roske.png";
import partnerFalck from "../../../../../public/images/New-landing/partner-falck.png";
import partnerAlb from "../../../../../public/images/New-landing/partner-alb.png";
import partnerFhir from "../../../../../public/images/New-landing/partner-fhir.png";
import partnerWisag from "../../../../../public/images/New-landing/partner-wisag.png";
import partnerHcm from "../../../../../public/images/New-landing/partner-hcm.png";

interface AboutUsProps {
  lng: string;
}

const AboutUs: React.FC<AboutUsProps> = ({ lng }) => {
  const { t }: { t: any } = useTranslation(lng, "new-landing");

  const partnersTitle = t("about-partners-title");

  const features = [
    {
      icon: featureApi,
      title: t("features.api.title"),
      description: t("features.api.description", { returnObjects: true }) as string[],
    },
    {
      icon: featureWorkflows,
      title: t("features.workflows.title"),
      description: t("features.workflows.description", { returnObjects: true }) as string[],
    },
    {
      icon: featureScanGo,
      title: t("features.scan-go.title"),
      description: t("features.scan-go.description", { returnObjects: true }) as string[],
    },
    {
      icon: featureAiModels,
      title: t("features.ai-models.title"),
      description: t("features.ai-models.description", { returnObjects: true }) as string[],
    },
    {
      icon: feature5g,
      title: t("features.5g.title"),
      description: t("features.5g.description", { returnObjects: true }) as string[],
    },
    {
      icon: featureEngine,
      title: t("features.engine.title"),
      description: t("features.engine.description", { returnObjects: true }) as string[],
    },
  ];

  const partners = [
    {
      logo: partnerRoske,
      name: "Roske",
      width: 100,
      height: 100,
    },
    {
      logo: partnerFalck,
      name: "Falck",
      width: 263,
      height: 100,
    },
    {
      logo: partnerAlb,
      name: "ALB",
      width: 142,
      height: 100,
    },
    {
      logo: partnerFhir,
      name: "FHIR",
      width: 168,
      height: 100,
    },
    {
      logo: partnerWisag,
      name: "WISAG",
      width: 305,
      height: 100,
    },
    {
      logo: partnerHcm,
      name: "HCM",
      width: 131,
      height: 100,
    },
  ];

  return (
    <section
      id="about"
      className="w-full bg-white pt-16 lg:pt-[100px] pb-[24px]"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative">
          <div className="text-center mb-8 lg:mb-16">
            <h2 className="text-omto-dark font-montserrat font-bold text-[28px] sm:text-[48px] leading-[1.4]">
              {t("about-title").split(' ')[0]} <span className="text-omto-blue">{t("about-title").split(' ')[1]}</span>
            </h2>
          </div>

          <div className="flex flex-col-reverse lg:flex-row gap-12 lg:gap-16 mb-12 lg:mb-28">
            <div className="lg:flex-[520] lg:min-w-0">
              <Partners partners={partners} title={partnersTitle} />
            </div>

            <div className="lg:flex-[645] lg:min-w-0">
              <div className="space-y-6">
                <p className="text-omto-dark font-montserrat font-medium text-[16px] sm:text-[18px] leading-8 text-justify">
                  {t("about-description-1")}
                </p>
                
                <p className="text-omto-dark font-montserrat font-medium text-[16px] sm:text-[18px] leading-8 text-justify">
                  {t("about-description-2")}
                </p>
              </div>
            </div>
          </div>

          <div className="mb-16">
            <Features features={features} />
          </div>

          <div className="flex justify-center">
            <NavigationButton
              text={t("about-navigation")}
              targetId="products"
              direction="down"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
